import qs from 'qs'
import { FC } from 'react'
interface IData {
  user_token: string
  card_token: string
  name_on_card: string
  one_time_token: string
}

type MarqetaIFrameType = 'marqeta.set-pin' | 'marqeta.activate-card'

const urls = {
  production: 'https://widgets.marqeta.com',
  sandbox: 'https://widgets-sandbox.marqeta.com'
}

export const Marqeta: FC<{ data: IData, type: MarqetaIFrameType }> = ({ data, type }:{ data: IData, type: MarqetaIFrameType }) => {
  const pathDirectory = type === 'marqeta.activate-card' ? '/activate_card' : '/set_pin'

  const explicitParameters = {
    query: {
      user_token: data.user_token,
      card_token: data.card_token,
      one_time_token: data.one_time_token,
      // sandbox: process.env.NEXT_PUBLIC_APP_ENV === 'development' ? '1' : '0',
      application_id: process.env.NEXT_PUBLIC_MARQETA_APPLICATION_ID_ENV,
      type: 'marqeta.set-pin'
    }
  }

  // const baseUrl = process.env.NEXT_PUBLIC_PCI_EMBED_URL || 'https://pci-embed.extra.app'
  const url = `${urls[process.env.NEXT_PUBLIC_APP_ENV]}${pathDirectory}?${qs.stringify(explicitParameters.query)}`
  return (
    // <MarqetaIFrame type={'setPIN'} explicitParameters={explicitParameters} />
    <>
      <iframe src={url} className="absolute top-0 left-0 w-screen h-screen" height={300} />
    </>
  )
}
